import styled from 'styled-components';

export const StatusCellContent = styled.div`
  position: relative;

  p:first-child {
    font-size: 16px;
    line-height: 130%;
    margin: 10px 0 0;
  }
`;
